import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from 'src/constants';
import { en, ru } from './locales';

const storedLanguage = localStorage.getItem('language');
const browserLanguages = Array.isArray(window.navigator.languages)
  ? window.navigator.languages
  : [window.navigator.language].filter(Boolean);

const detectBrowserLanguage = () => {
  for (const language of browserLanguages) {
    const normalized = String(language || '')
      .toLowerCase()
      .split('-')[0];

    if (SUPPORTED_LANGUAGES.includes(normalized)) {
      return normalized;
    }
  }

  return DEFAULT_LANGUAGE;
};

const selectedLanguage = SUPPORTED_LANGUAGES.includes(storedLanguage)
  ? storedLanguage
  : detectBrowserLanguage();

if (!storedLanguage && selectedLanguage) {
  localStorage.setItem('language', selectedLanguage);
}

i18n.use(initReactI18next).init({
  resources: {
    en,
    ru
    // de: de,
    // fr: fr,
  },
  lng: selectedLanguage,
  fallbackLng: 'en',
  debug: true,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
